import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { APP_CONFIG } from '../../app.config';
import { Observable, Subscription } from 'rxjs';
import { ApiService, PageService, SettingsService } from '@gallaghercp/core-frontend';

@Component({
  selector: 'core-footer',
  templateUrl: './footer.component.html',
  styles: [],
  standalone: false,
})
export class FooterComponent implements OnInit, OnDestroy {
  private pages = inject(PageService);
  private api = inject(ApiService);
  private settings = inject(SettingsService);

  copyright = APP_CONFIG.copyright;
  pages$?: Observable<any>;
  logoUrl?: any;
  protected logoInvertedUrl!: string;
  protected logoTransparentUrl!: string;
  darkMode?: boolean;
  subscriptions: Subscription[] = [];

  ngOnInit() {
    this.api.zoneChangeEmit.subscribe(() => {
      this.pages$ = this.pages.getPages();
    });

    this.subscriptions.push(
      this.settings.isDarkMode().subscribe((state: any) => {
        this.darkMode = state;
        this.updateLogoUrl();
      }),
    );

    this.subscriptions.push(
      this.settings.getInvertedLogo().subscribe((logoUrl: any) => {
        this.logoInvertedUrl = logoUrl;
        this.updateLogoUrl();
      }),
    );

    this.subscriptions.push(
      this.settings.getTransparentLogo().subscribe((logoUrl: any) => {
        this.logoTransparentUrl = logoUrl;
        this.updateLogoUrl();
      }),
    );
  }

  updateLogoUrl(): void {
    this.logoUrl = !this.darkMode ? this.logoInvertedUrl : this.logoTransparentUrl;
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
  }
}
